import classes from "./DotBoxLoader.module.css";
import { readDarkModeSetting } from "src/data/person/darkModeFunctions";

export default function DotBoxLoader() {
  const darkMode = readDarkModeSetting() ? true : false;
  const styles = {
    div2: {
      width: "250px",
      height: "100%",
      zIndex: 1001,
      background: darkMode ? "#292929" : "#D9D9D9",
      color: darkMode ? "rgba(255,255,255,0.87)" : "rgba(0,0,0,0.87)",
      borderRadius: "10px",
      opacity: 0.8,
    },
  };

  return (
    <div className={classes.div1}>
      <div className="center" style={styles.div2}>
        <div className={darkMode ? classes.loader_dark : classes.loader}></div>
      </div>
    </div>
  );
}
